import { generateSecureData } from 'services/secureDataSharing';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ICreateSecureDataParams } from 'services/secureDataSharing/types';

export const ThunkGenerateSecureData = createAsyncThunk<string, ICreateSecureDataParams>(
  'secureDataSharing/generateSecureData',
  payload => generateSecureData(payload).then(r => r.data.data),
);
